import classNames from "classnames"

import * as Scrivito from "scrivito"

import { FeatureWidgetView } from "./Components/FeatureWidgetView"
import { FeatureWidget } from "./FeatureWidgetClass"

Scrivito.provideComponent(FeatureWidget, ({ widget }) => {
  return (
    <FeatureWidgetView
      elementId={widget.get("elementId")}
      topHeadline={
        <Scrivito.ContentTag content={widget} attribute="topHeadline" />
      }
      headline={<Scrivito.ContentTag content={widget} attribute="headline" />}
      text={<Scrivito.ContentTag content={widget} attribute="text" />}
      buttons={
        Scrivito.isInPlaceEditingActive() ||
        (widget.get("buttons")?.length ?? 0) > 0 ? (
          <Scrivito.ContentTag content={widget} attribute="buttons" />
        ) : null
      }
      content={
        <div className={classNames("feature-widget__image")}>
          <Scrivito.ContentTag content={widget} attribute="imageWidgets" />
        </div>
      }
      alternativeBackground={widget.get("alternativeBackground")}
      objectFit={widget.get("objectFit")}
    />
  )
})
